import * as graphql from '@treams/treams-network';
import { Heading3, Paragraph } from '@treams/treams-ui';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'auth') {
		return {
			title: 'Koppelen met Loket',
			description:
				'Om te verbinden met Loket, moet je inloggen via de onderstaande button. Je wordt doorverwezen naar de site van Loket en krijgt daarna een scherm te zien met een overzicht van de gegevens die je gaat delen. Vervolgens kun je hier akkoord op geven.',
		};
	}

	if (key === 'employerIDs') {
		return {
			title: 'Werkgevers',
			description: 'Kies hier welke werkgevers uit Loket je wil synchroniseren.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

function Description() {
	return (
		<>
			<Heading3 mb={1}>Innovatief:</Heading3>
			<Paragraph mb={2}>
				Wij Loket.nl zijn altijd opzoek naar vernieuwing en verbetering als het gaat om HR en
				salaris. Zo kunnen wij de verwachting van al onze gebruikersgroepen telkens weer
				overtreffen.
			</Paragraph>
			<Heading3 mb={1}>Verantwoordelijk:</Heading3>
			<Paragraph mb={2}>
				We zijn HR en salaris professionals. Daarom mag je van ons verwachten dat we oprecht
				geïnteresseerd zijn in alles wat dit doelgebied raakt. Wij luisteren oprecht naar onze
				klanten en weten wat voor jullie nodig is om succesvol te zijn. Wij kennen ons vak als geen
				andere HR en salarisprofessional in de markt. Accountants- en administratiekantoren die op
				zoek zijn naar maximale efficiëntie voor hun dienstverlening en de beste gebruikerservaring
				voor hun klanten, kiezen voor de HR- en salarisoplossingen van Loket.nl
			</Paragraph>
		</>
	);
}

export default function Loket() {
	return (
		<ProductLayout
			id="loket"
			type={graphql.ConnectorType.Loket}
			description={<Description />}
			headerImageURL="https://assets.ontreams.com/marketplace/loket-wide.jpg"
			translate={translate}
			pricingLink="https://www.loket.nl/demo/"
			documentationLink="https://treams.notion.site/Uitleg-Loket-integreren-met-Treams-27264530469647adb66c1826f7903460"
		/>
	);
}

export function LoketTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="loket"
			title="Loket"
			description="Salarisadministratie en HR: alles in één complete app."
			logoImageURL="https://assets.ontreams.com/marketplace/loket.png"
			selected={props.selected}
		/>
	);
}
